import { render, staticRenderFns } from "./SynchronizeBanks.vue?vue&type=template&id=4bbae177&"
import script from "./SynchronizeBanks.vue?vue&type=script&lang=js&"
export * from "./SynchronizeBanks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports